module.exports = __webpack_public_path__ + "img/track_changes.5582dcf1.svg";